<mat-card class="offer-details-view-card-container default-card-design">
    <mat-card-content>
        <div class="section-title"> Important Details </div>
        <div
            class="section-content"
            novaSkeletonLoader
            [isLoading]="offerData == null"
            [repeat]="4"
            width="rand">
            @if (offerData?.otherDetails) {
                <span [innerHTML]="offerData?.otherDetails | sanitizer"></span>
            }
        </div>
    </mat-card-content>
</mat-card>
<mat-card class="offer-details-view-card-container default-card-design">
    <mat-card-content>
        <div class="section-title">Internal Offer Details</div>
        <div
            class="section-content"
            novaSkeletonLoader
            [isLoading]="offerData == null"
            [repeat]="4"
            width="rand">
            @if (offerData?.offerType === offerTypeEnum.Agency) {
                <div class="content-row">
                    <div class="content-label">Vendor</div>
                    <div class="content-value">
                        {{ offerData?.vendorName }}
                    </div>
                </div>

                <div class="content-row">
                    <div class="content-label">Vendor Contact</div>
                    <div class="content-value">
                        <a
                            class="nova__link"
                            href="mailto:{{ offerData?.vendorContactEmail }}"
                            >{{ offerData?.vendorContactName }}</a
                        >
                    </div>
                </div>
            }

            <div class="content-row">
                <div class="content-label">Candidate Name</div>
                <div class="content-value">
                    @if (urlParent && offerData?.candidateId) {
                        <a
                            class="nova__link"
                            target="_blank"
                            [routerLink]="['/recruiting/candidates', offerData?.candidateId, 'new-profile']"
                            rel="noopener"
                            >{{ offerData?.candidateName }}</a
                        >
                    } @else {
                        {{ offerData?.candidateName }}
                    }
                    @if (offerData?.candidateEmail) {
                        <span class="ml-1">{{ '(' + offerData.candidateEmail + ')' }}</span>
                    }
                </div>
            </div>
            <div class="content-row">
                <div class="content-label">Offer Status</div>
                <div class="content-value">
                    {{ offerData?.status }}
                </div>
            </div>
            @if (
                offerData?.hospitalTypeId === hospTypeEnum.WorkforceDisruptionClinical ||
                offerData?.hospitalTypeId === hospTypeEnum.WorkforceDisruptionNonClinical
            ) {
                <div class="content-row">
                    <div class="content-label">WFD Priority</div>
                    <div class="content-value">
                        <nova-wfd-priority-returner-chips-view
                            [wfdPriority]="wfdPriority"
                            [isWfdReturner]="isWfdReturner" />
                    </div>
                </div>
            }
            <div class="content-row">
                <div class="content-label">Contract Type</div>
                <div class="content-value">{{ offerData?.contractType }}</div>
            </div>
            @if (offerData?.offerType === offerTypeEnum.Direct) {
                <div class="content-row">
                    <div class="content-label">Contract Status</div>
                    <div class="content-value">
                        <span
                            (click)="
                                goToContractRequest.emit({
                                    contractRequestId: offerData?.contractRequestId,
                                    marginId: offerData?.marginId
                                })
                            "
                            (keydown.enter)="
                                goToContractRequest.emit({
                                    contractRequestId: offerData?.contractRequestId,
                                    marginId: offerData?.marginId
                                })
                            "
                            class="nova__link"
                            >{{ offerData?.contractRequestStatus }}
                        </span>
                    </div>
                </div>
            }
            <div class="content-row">
                <div class="content-label">Job ID</div>
                <div class="content-value">
                    <span
                        (click)="goToJobId.emit(offerData.jobId)"
                        (keydown.enter)="goToJobId.emit(offerData.jobId)"
                        class="nova__link">
                        {{ offerData?.jobId }}
                    </span>
                </div>
            </div>

            @if (offerData?.offerType === offerTypeEnum.Direct) {
                <div class="content-row">
                    <div class="content-label">Offer Margin</div>
                    <div class="content-value offer-margin-value">
                        @if (offerData?.marginId) {
                            <div>
                                <a
                                    (click)="openMarginCalculator.emit(offerData?.marginId)"
                                    class="nova__link ng-star-inserted"
                                >
                                    {{ offerData?.marginId }}
                                </a>
                                @if (offerData?.importedFromMarginId) {
                                    (Margin created from {{ offerData?.importedFromMarginId }} margin
                                    {{ offerData?.marginImportDateUtc | date: 'MM/dd/yyyy - hh:mm a' }})
                                }
                            </div>
                        }
                        @if (showOfferMarginDifferences) {
                            <div>
                                <span
                                    (click)="openMarginDifferences.emit()"
                                    (keydown.enter)="openMarginDifferences.emit()"
                                    class="nova__link"
                                >
                                    View Differences
                                </span>
                            </div>
                        }
                        @if (showSampleMarginButton || showCreateAndImportMarginButtons || showImportMarginButton) {
                            <div class="offer-margin-buttons-row">
                                @if (showSampleMarginButton) {
                                    <button
                                        mat-flat-button
                                        data-qa-id="addSampleMargin"
                                        class="margin-btn"
                                        color="primary"
                                        (click)="duplicateSampleMargin.emit()"
                                        [disabled]="disableSampleMargin"
                                        [matTooltip]="sampleMarginTooltip"
                                    >
                                        ADD SAMPLE MARGIN
                                    </button>
                                }

                                @if (showCreateAndImportMarginButtons) {
                                    <button
                                        mat-stroked-button
                                        color="secondary"
                                        (click)="showImportMarginDialog.emit()"
                                    >
                                        IMPORT MARGIN
                                    </button>
                                    <button
                                        mat-stroked-button
                                        color="secondary"
                                        (click)="createOfferMargin.emit()"
                                    >
                                        CREATE MARGIN
                                    </button>
                                }

                                @if (showImportMarginButton) {
                                    <button
                                        mat-stroked-button
                                        class="margin-btn"
                                        color="secondary"
                                        (click)="showImportMarginDialog.emit()"
                                    >
                                        IMPORT MARGIN
                                    </button>
                                }
                            </div>
                        }
                    </div>
                </div>
            }

            <div class="content-row">
                <div class="content-label">Facility Rate</div>
                <div class="content-value">{{ offerData?.facilityRate | currency }}</div>
            </div>
            @if (offerData?.offerType === offerTypeEnum.Agency) {
                <div class="content-row">
                    <div class="content-label">Vendor Rate</div>
                    <div class="content-value">
                        {{ offerData?.vendorRate | currency }}
                    </div>
                </div>
            } @else {
                <div class="content-row">
                    <div class="content-label">Target Margin</div>
                    <div class="content-value">
                        {{ offerData?.jobTargetMargin ? offerData?.jobTargetMargin + '%' : '0%' }}
                    </div>
                </div>
            }

            @if (offerData?.offerType === offerTypeEnum.Direct) {
                <div class="content-row">
                    <div class="content-label">Aya Paid Bonus</div>
                    <div
                        class="content-value"
                        data-qa-id="ayaPaidBonus">
                        {{ offerData?.ayaPaidBonus ?? 0 | currency }}
                    </div>
                </div>
            }
            @if (offerData?.recruiterBonus) {
                <div class="content-row">
                    <div class="content-label">Doughboy</div>
                    <div class="content-value doughboy-value">
                        <div>{{ offerData?.recruiterBonus ?? 0 | currency }}</div>
                        <div class="doughboy-icon"
                            ><nova-recruiter-bonus [bonus]="offerData?.recruiterBonus"></nova-recruiter-bonus
                        ></div>
                    </div>
                </div>
            }
            @if (offerData?.isRemoteBooking !== null) {
                <div
                    class="content-row"
                    data-qa-id="job-details-work-model">
                    <div class="content-label">Work Model</div>
                    <div
                        class="content-value"
                        data-qa-id="ProfessionView">
                        {{ !offerData?.isRemoteBooking ? 'On-site' : 'Remote' }}</div
                    >
                </div>
            }
            @if (offerData?.isPatientFacing !== null) {
                <div
                    class="content-row"
                    data-qa-id="job-details-work-type">
                    <div class="content-label">Work Type</div>
                    <div class="content-value">
                        {{ (offerData?.isPatientFacing ?? true) ? 'Patient-Facing' : 'Non-Patient-Facing' }}
                    </div>
                </div>
            }
            @if (offerData?.offerType === offerTypeEnum.Direct) {
                <div class="content-row ppl-instructions">
                    <div class="content-label">
                        <div>Pipelines Request Instructions</div>
                        <div>
                            <mat-icon
                                class="pipeline-request-instruction-info-icon"
                                matTooltip="Use this field to specify what should be added to the contract -
                    such as special rate details (holiday, RTO, OT), end date rules, or unique
                    shift information for the traveler's contract"
                                >info</mat-icon
                            >
                        </div>
                    </div>
                    <div class="content-value">
                        {{ offerData?.pipelineRequestInstructions }}
                    </div>
                </div>
            }
        </div>
    </mat-card-content>
</mat-card>
<mat-card class="offer-details-view-card-container default-card-design">
    <mat-card-content>
        <div class="section-title">
            <span>Candidate Offer Details</span>
            @if (offerData && displayCopyButton) {
                <button
                    mat-stroked-button
                    color="secondary"
                    (click)="copyOfferDetailsToClipboard($event)"
                    class="copy-offer-details-button"
                    matTooltip="Copy Offer Summary to Clipboard"
                    matTooltipPosition="above"
                    data-qa-id="copyJobDetailsButton">
                    <mat-icon
                        fontIcon="content_copy"
                        aria-hidden="false"
                        aria-label="Copy Offer Summary to Clipboard"></mat-icon>
                    COPY OFFER SUMMARY
                </button>
            }
        </div>
        <div
            class="section-content"
            #offerDetailsContent
            novaSkeletonLoader
            [isLoading]="offerData == null"
            [repeat]="4"
            width="rand">
            <div class="content-row">
                <div class="content-label"> Facility </div>
                <div class="content-value">
                    <a
                        (click)="openFacility.emit(offerData?.facilityId)"
                        class="nova__link">
                        {{ offerData?.facilityName }}</a
                    >
                    <span class="ml-1">{{ facilityCityAndState }}</span>
                </div>
            </div>
            <div class="content-row">
                <div class="content-label">Position Type</div>
                <div class="content-value">{{ offerData?.positionType }}</div>
            </div>
            @if (offerData?.offerType === offerTypeEnum.Direct) {
                <div class="content-row">
                    <div class="content-label">Unit</div>
                    <div class="content-value">
                        @if (offerData?.unitDescriptionFormId) {
                            <a
                                (click)="
                                    openUnitFormUrl.emit({
                                        event: $event,
                                        unitFormId: offerData?.unitDescriptionFormId
                                    })
                                "
                                class="nova__link"
                                target="_blank"
                                rel="noopener">
                                {{ offerData?.unitName }}
                            </a>
                        } @else {
                            {{ offerData?.unitName }}
                        }
                    </div>
                </div>
            }
            <div class="content-row">
                <div class="content-label">Candidate Profession</div>
                <div class="content-value">
                    {{ offerData?.professionName }}
                </div>
            </div>
            <div class="content-row">
                <div class="content-label">Job Profession</div>
                <div class="content-value">
                    {{ jobProfessionName || offerData?.jobProfessionName }}
                </div>
            </div>
            <div class="content-row">
                <div class="content-label">Job Specialty</div>
                <div class="content-value">{{ offerData?.expertiseName }}</div>
            </div>
            <div class="content-row">
                <div class="content-label">Payroll Work Week</div>
                <div class="content-value">{{ offerData?.payrollWorkweek }}</div>
            </div>
            <div class="content-row">
                <div class="content-label">Contract Length</div>
                <div class="content-value">
                    {{ displayedContractLengthWeeks }} Weeks ({{ displayedContractLengthDays }}) Days
                </div>
            </div>
            <div class="content-row">
                <div class="content-label">Start</div>
                <div class="content-value">{{ offerData?.startDate }}</div>
            </div>
            <div class="content-row">
                <div class="content-label">End</div>
                <div class="content-value">{{ endDateTextWithoutWeeks }}</div>
            </div>
            @if (offerData?.hasRequestedTimeOff) {
                <div class="content-row">
                    <div class="content-label">
                        RTO
                        <nova-rto-alert-icon [enabled]="showRTOAlertOnStartEndDates"> </nova-rto-alert-icon>
                    </div>
                    <div class="content-value flex-col gap-4">
                        @if (requestedTimeOffDatesArray.length > 0) {
                            @for (d of requestedTimeOffDatesArray; track d) {
                                <span>{{ d }}</span>
                            }
                        }
                    </div>
                </div>
                <div class="content-row">
                    <div class="content-label">RTO Approval</div>
                    <div class="content-value">{{ rtoApprovalStatus }}</div>
                </div>
            }
            <div class="content-row">
                <div class="content-label">Shifts</div>
                <div class="content-value">{{ offerData?.shiftsText }}</div>
            </div>
            @if (offerData?.shiftDetails) {
                <div class="content-row">
                    <div class="content-label">Shift Details</div>
                    <div class="content-value">{{ offerData?.shiftDetails }}</div>
                </div>
            }
        </div>
    </mat-card-content>
</mat-card>
